export function parseTermSheetPage(rawText) {
  if (!rawText) return [];
  const lines = rawText.split('\n');
  const sections = [];
  let i = 0;

  const isPageMarker = (s) => /^Page \d+ of \d+$/i.test(s);
  const isBoilerplate = (s) =>
    /^Co\. Reg\. No\./i.test(s) ||
    /^Oversea-Chinese/i.test(s);

  const isTableLine = (s) => {
    if (!s) return false;
    if (s.includes('|')) return true;
    if (s.includes('\t') && s.split('\t').filter((c) => c.trim()).length >= 2) return true;
    return false;
  };

  const isKVLine = (s) =>
    /^([A-Za-z][A-Za-z\s/().,\-]+?):\s+.+/.test(s);

  const isTitleLine = (s) =>
    s.endsWith(':') && s.length < 60 && !s.includes('\n');

  while (i < lines.length) {
    const trimmed = lines[i].trim();
    if (!trimmed || isPageMarker(trimmed) || isBoilerplate(trimmed)) {
      i++;
      continue;
    }

    // Pipe-separated table
    if (trimmed.includes('|')) {
      const tableLines = [];
      while (i < lines.length && lines[i].trim().includes('|')) {
        const t = lines[i].trim();
        if (isPageMarker(t) || isBoilerplate(t)) {
          i++;
          break;
        }
        tableLines.push(t);
        i++;
      }
      const rows = tableLines.map((l) => l.split('|').map((c) => c.trim()));
      sections.push({ type: 'table', headers: rows[0] || [], rows: rows.slice(1) });
      continue;
    }

    // Tab-separated table (2+ columns)
    if (trimmed.includes('\t')) {
      const cols = trimmed.split('\t').map((c) => c.trim());
      if (cols.filter((c) => c).length >= 2) {
        const tableLines = [];
        while (i < lines.length && lines[i].trim().includes('\t')) {
          const t = lines[i].trim();
          if (isPageMarker(t) || isBoilerplate(t)) {
            i++;
            break;
          }
          tableLines.push(t.split('\t').map((c) => c.trim()));
          i++;
        }
        sections.push({ type: 'table', headers: tableLines[0] || [], rows: tableLines.slice(1) });
        continue;
      }
    }

    // Key: Value pair (value non-empty)
    const kvMatch = trimmed.match(/^([A-Za-z][A-Za-z\s/().,\-]+?):\s+(.+)$/);
    if (kvMatch) {
      const key = kvMatch[1].trim();
      let value = kvMatch[2].trim();
      i++;
      // Collect continuation lines
      while (i < lines.length) {
        const next = lines[i].trim();
        if (!next || isPageMarker(next) || isBoilerplate(next)) {
          i++;
          break;
        }
        if (isTableLine(next) || isKVLine(next) || isTitleLine(next)) break;
        value += ' ' + next;
        i++;
      }
      const last = sections[sections.length - 1];
      if (last && last.type === 'kv') {
        last.items.push({ key, value });
      } else {
        sections.push({ type: 'kv', items: [{ key, value }] });
      }
      continue;
    }

    // Section title: ends with colon, no value
    if (isTitleLine(trimmed)) {
      const title = trimmed.replace(/:$/, '').trim();
      i++;
      // Check if next is a table
      if (i < lines.length && isTableLine(lines[i].trim())) {
        const isPipe = lines[i].trim().includes('|');
        const tableLines = [];
        while (i < lines.length && isTableLine(lines[i].trim())) {
          const t = lines[i].trim();
          if (isPageMarker(t) || isBoilerplate(t)) {
            i++;
            break;
          }
          if (isPipe) {
            tableLines.push(t.split('|').map((c) => c.trim()));
          } else {
            tableLines.push(t.split('\t').map((c) => c.trim()));
          }
          i++;
        }
        sections.push({ type: 'table', title, headers: tableLines[0] || [], rows: tableLines.slice(1) });
        continue;
      }
      sections.push({ type: 'title', text: title });
      continue;
    }

    // Regular text block
    const textLines = [];
    while (i < lines.length) {
      const next = lines[i].trim();
      if (!next || isPageMarker(next) || isBoilerplate(next)) {
        i++;
        break;
      }
      if (isTableLine(next) || isKVLine(next) || isTitleLine(next)) break;
      textLines.push(next);
      i++;
    }
    if (textLines.length) {
      // Merge with previous text section if consecutive
      const last = sections[sections.length - 1];
      if (last && last.type === 'text') {
        last.lines.push(...textLines);
      } else {
        sections.push({ type: 'text', lines: textLines });
      }
    }
  }

  return sections;
}
